import {
    Document,
    Font,
    Page,
    PDFViewer,
    StyleSheet,
    View
} from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import TableHeader from "../components/layouts/pdf/Header";
import KopSurat from "../components/layouts/pdf/Kopsurat";
import TableAbsen from "../components/layouts/pdf/TableAbsen";
import TableGaji from "../components/layouts/pdf/TableGaji";
import { AbsensiData } from "./absenhistory";
// Create styles
export const styles = StyleSheet.create({
    container: {
        padding: "20",
    },
    textlg: {
        fontFamily: 'Open Sans',
        fontSize: 18,
        fontWeight: 600
    },
    textmd: {
        fontSize: 16
    },
    textsm: {
        fontSize: 14
    },
    textxs: {
        fontSize: 12
    },
    section: {
        margin: 10,
        padding: 10,
    },
    viewer: {
        width: window.innerWidth, //the pdf viewer will take up all of the width and height
        height: window.innerHeight,
    },
    headersection: {
        flexDirection: "row",
        fontSize: 14
    },
    headervalue: {
        marginLeft: 20
    },
    headertitle: {
        marginVertical: 4,
        minWidth: 110
    }
});
export interface DataGajian {
    label: string;
    content: string;
    type: "debit" | "credit";
}
export interface DataEmployee {
    dateFrom: string;
    dateTo: string;
    name: string;
}
export interface LabelType {
    label: string;
    value: number;
}
export default function PDFDownload() {
    const [datalistdebit, setDatalistdebit] = useState<LabelType[]>([])
    const [datalistcredit, setDatalistcredit] = useState<LabelType[]>([])
    const [dataemployee, setDataemployee] = useState<DataEmployee>()
    const [dataAbsen, setDataAbsen] = useState<AbsensiData[]>([]);
    Font.register({
        family: 'Open Sans',
        fonts: [
            { src: '../assets/fonts/open-sans-regular.ttf' },
            { src: '../assets/fonts/open-sans-600.ttf', fontWeight: 600 },
            { src: '../assets/fonts/open-sans-800.ttf', fontWeight: 800 }
        ]
    });
    const calculateGaji = (datagajian: DataGajian[]) => {
        if (datagajian && datagajian.length > 0) {
            const listDebit: LabelType[] = []
            const listCredit: LabelType[] = []
            for (let i = 0; i < datagajian.length; i++) {
                if (datagajian[i].type == "debit") {
                    listDebit.push({
                        label: datagajian[i].label,
                        value: Number(datagajian[i].content),
                    })
                } else if (datagajian[i].type == "credit") {
                    listCredit.push({
                        label: datagajian[i].label,
                        value: Number(datagajian[i].content),
                    })
                }
            }
            setDatalistdebit(listDebit)
            setDatalistcredit(listCredit)
        }
    }
    useEffect(() => {
        let dataAbsen: AbsensiData[] = []
        let dataGajian: DataGajian[] = []
        let dataemployee: DataEmployee = {
            dateFrom: "",
            dateTo: "",
            name: ""
        }
        if (localStorage.getItem("data-absen") && localStorage.getItem("data-absen") !== null) {
            dataAbsen = JSON.parse(localStorage.getItem("data-absen")!) as AbsensiData[] || []
            setDataAbsen(dataAbsen)
        }
        if (localStorage.getItem("data-gajian") && localStorage.getItem("data-gajian") !== null) {
            dataGajian = JSON.parse(localStorage.getItem("data-gajian")!) as DataGajian[] || []
        }
        if (localStorage.getItem("data-employee") && localStorage.getItem("data-employee") !== null) {
            dataemployee = JSON.parse(localStorage.getItem("data-employee")!) as DataEmployee || ""
            setDataemployee(dataemployee)
        }
        if (dataGajian.length === 0 || dataAbsen.length === 0 || !dataemployee) {
            window.close()
        } else {
            calculateGaji(dataGajian)
        }
    }, [])
    return (<PDFViewer style={styles.viewer} >
        {/* Start of the document*/}
        <Document>
            {/*render a single page*/}
            <Page size="A4" style={styles.container}>
                <KopSurat />
                <View style={{ borderTop: "2px solid black", marginBottom: 10 }}>
                </View>
                {dataemployee && (
                    <TableHeader
                        dateTo={dataemployee.dateTo}
                        dateFrom={dataemployee.dateFrom}
                        name={dataemployee.name}
                    />
                )}
                <View style={{ marginVertical: 10 }} />
                <TableGaji listCredit={datalistcredit} listDebit={datalistdebit} />
            </Page>
            <TableAbsen dataAbsen={dataAbsen} />
        </Document>
    </PDFViewer>
    )
}